import React from 'react'
import { Card, Text } from "@nextui-org/react";
import { Link, useLocation } from 'react-router-dom';

function SearchesSideCard() {
    return (
        <Card className='statsSiderbarCard'>
            <Card.Body className=''>
                <Text className='cardsStatsText'>
                    0 cards out of 3 per month
                </Text>

                <div className='mx-4 mt-4'>
                    <Link to="/account">
                    <button
                        type="button"
                        className="inline-flex items-center justify-center w-full px-4 py-3 text-sm font-semibold leading-5 text-white transition-all duration-200 bg-red-600 border 
                        border-transparent rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 hover:bg-red-500"
                    >
                        <h5 className='upgradeNowText'>
                            Upgrade Now
                        </h5>
                    </button>
                    </Link>
                </div>
            </Card.Body>
        </Card>
    )
}

export default SearchesSideCard